module.exports = __webpack_public_path__ + "static/media/environmental.af908501.jpg";